import React from "react"
import PropTypes from "prop-types"

import { ACENTO_COMPRAS, ACENTO_VENTAS } from "../static"
import { moneda, numero, porcentaje } from "../format"
import KpiCard from "./KpiCard"
import ProgressBar from "./ProgressBar"
import TrendChartCard from "./TrendChartCard"

/** «11 / 12» más su barra y el apunte de inactivos. */
const CuentaEmpresas = ({ label, icono, cuenta }) => {
  const total = cuenta.active + cuenta.inactive

  return (
    <KpiCard
      label={label}
      icono={icono}
      valor={numero(cuenta.active)}
      unidad={`/ ${numero(total)}`}
      hint={
        cuenta.inactive === 1
          ? "1 inactivo"
          : `${numero(cuenta.inactive)} inactivos`
      }
    >
      <ProgressBar porcentaje={total > 0 ? (cuenta.active / total) * 100 : 0} />
    </KpiCard>
  )
}

CuentaEmpresas.propTypes = {
  label: PropTypes.string.isRequired,
  icono: PropTypes.string.isRequired,
  cuenta: PropTypes.object.isRequired,
}

const GeneralTab = ({ state, events }) => (
  <>
    <div className="res-grid-kpi res-anim">
      <KpiCard
        label="Pedidos del día"
        icono="bx bx-copy-alt"
        variante="accent"
        valor={numero(state.contadores.orders)}
      />

      <CuentaEmpresas
        label="Proveedores activos"
        icono="bx bx-user"
        cuenta={state.contadores.providers}
      />

      <CuentaEmpresas
        label="Clientes activos"
        icono="bx bx-group"
        cuenta={state.contadores.clients}
      />

      <KpiCard
        label="Margen del periodo"
        icono="bx bx-trending-up"
        variante="dark"
        valor={state.margen ? moneda(state.margen.importe) : "—"}
        formato="money"
        hint={
          state.margen && !state.margen.mismoPeriodo
            ? state.margen.detalle
            : null
        }
      >
        {state.margen && state.margen.porcentaje !== null && (
          <div className="res-chip-row">
            <span
              className={`res-chip${state.margen.porcentaje < 0 ? " is-down" : ""}`}
            >
              {porcentaje(state.margen.porcentaje)}
            </span>
            <span className="res-chip-note">sobre ventas</span>
          </div>
        )}
      </KpiCard>
    </div>

    <TrendChartCard
      titulo="Ventas"
      acento={ACENTO_VENTAS}
      state={state.ventas}
      events={events.ventas}
    />

    <TrendChartCard
      titulo="Compras"
      acento={ACENTO_COMPRAS}
      state={state.compras}
      events={events.compras}
      proveedores={state.proveedores}
    />
  </>
)

GeneralTab.propTypes = {
  state: PropTypes.object.isRequired,
  events: PropTypes.object.isRequired,
}

export default GeneralTab
